import { use } from 'react';
import { LocaleContext } from 'contexts/LocaleContext';

// ==============================|| LOCALE - HOOKS ||============================== //

export default function useLocale() {
  return use(LocaleContext);
}
